import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ICashOutRequest } from 'src/app/shared/interfaces/cashOutRequest';
import { ICashRequestInp } from 'src/app/shared/interfaces/cashRequestInp';
import { IChargeWalletInp } from 'src/app/shared/interfaces/chatgeWalletInp';
import { IFinancialTransaction } from 'src/app/shared/interfaces/financialTransaction';
import { ETransactionType } from 'src/app/shared/interfaces/transactionType-enum';
import { FakeDataService } from 'src/app/shared/mock/fake-data.service';
import { ModalComponent } from 'src/app/shared/modal/modal.component';
import { ApiService } from 'src/app/shared/services/api.service';

@Component({
  selector: 'app-user-wallet',
  templateUrl: './user-wallet.component.html',
  styleUrl: './user-wallet.component.css',
})
export class UserWalletComponent implements OnInit {

  wallet: number;
  transactionType = ETransactionType;
  transactionList: IFinancialTransaction[];
  walletInp: IChargeWalletInp = {
    amount: 0,
    clientUrl: ''
  }
  requestList: ICashOutRequest[];
  cashReqInp: ICashRequestInp = {
    timeType: 2,
    price: 0
  }
  searchInp = {
    title: '',
    pageIndex: 0,
    pageSize: 0
  }

  first: number = 0 ;
  rows: number = 10;
  pageSize = 10;  
  currentpage = 1;
  collectionSize: number = 10;

  first1: number = 0 ;
  rows1: number = 10;
  pageSize1 = 10;  
  currentpage1 = 1;
  collectionSize1: number = 10;


  @ViewChild('modal') modal!: ModalComponent;
  @ViewChild('req') req!: ModalComponent;

  transactionStatus = [
    {title:'نا مشخص' , value:1},
    {title:'در حال بررسی' , value:2},
    {title:'انجام شده' , value:3},
    {title:'لغو شده' , value:4}
  ]

  constructor(
    private apiService: ApiService,
    private router: Router,
    private messageService: MessageService,
    private fakeDataService: FakeDataService
  ){}


  ngOnInit(): void {
    this.getWalletAmount();
    this.getFinanceTransactions(0);
    this.getRequestsList(0);
  }

  getWalletAmount() {

    this.apiService.apiCall('get', '/api/User/GetWalletAmount', this.searchInp).subscribe((res: any) => {
      console.log(res);
      this.wallet = res.body.model;
    })
  }

  getFinanceTransactions(page) {
    // this.fakeDataService.getTransactions().subscribe((res: [IFinancialTransaction]) => {
    //   this.transactionList = res;
    // })
    this.searchInp = {
      title: this.searchInp.title,
      pageIndex: page+1,
      pageSize: this.pageSize
    }
    this.apiService.apiCall('post', '/api/User/GetTransactions', this.searchInp).subscribe((res: any) => {
      console.log(res);
      
      this.transactionList = res.body.model;
      this.collectionSize1 = res.body.collectionSize;
    })
  }

  chargeUserWallet() {
    this.walletInp = {
      amount: this.walletInp.amount,
      clientUrl: window.location.origin+this.router.url
    }
    console.log(this.walletInp);
    
    this.apiService.apiCall('post', '/api/User/ChargeWallet', this.walletInp).subscribe((res: any) => {
      console.log(res);
      
      if(res.body.isSuccess==true){
        window.location.href = res.body.model.zarinUrl;
      } else {
        this.messageService.add({severity: 'error', summary: 'خطا', detail: res.body.message });
      }
    })
  }

  getRequestsList(page) {
    this.searchInp = {
      title: this.searchInp.title,
      pageIndex: page+1,
      pageSize: this.pageSize,
      // status: Number(this.searchInp.status)!=0?Number(this.searchInp.status):null,
      // type: Number(this.searchInp.type)!=0?Number(this.searchInp.type):null
    }
    this.apiService.apiCall('post', '/api/User/GetAllUserCashOutRequest', this.searchInp).subscribe((res: any) => {
      console.log(res);
      
      this.requestList = res.body.model;
      this.collectionSize = res.body.collectionSize;
    })
  }

  sendRequest() {
    this.apiService.apiCall('post', '/api/User/AddCashOutRequest', this.cashReqInp).subscribe((res: any) => {
      console.log(res);

      if (res.body.isSuccess == true) {
        this.modal.close();
        
        this.messageService.add({severity: 'success', summary: 'موفق', detail: 'درخواست شما با موفقیت ثبت شد.' });
      } else {
        this.messageService.add({severity: 'error', summary: 'خطا', detail: res.body.message });
      }
    })
  }

}
